export default {
  widgets: {
    problemCasesListTable: {
      headers: ['Mijoz', 'Holat', 'Javobgar shaxs', 'Sana', 'Izohlar'],
      noComments: "Hech qanday izoh yo'q",
    },
  },
};
